<template>
  <div class="header-info">
    <div class="info-block">
      <h3>{{ title }}</h3>
      <p class="sub-title">
        <fa v-if="icon && isFontAwesome" :icon="icon" />
        <slot name="sub-title"></slot>
      </p>
    </div>
    <div class="control-block">
      <slot name="controls"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    }
  },
  computed: {
    isFontAwesome () {
      return this.icon.substring(0,2) !== 'el'
    }
  },
  created () {
    this.$root.pageTitle = this.title
  }
}
</script>

<style lang="scss" scoped>

  @include breakpoint (xs) {
    h3 {
      font-size: 42px;
    }
  }

  .sub-title {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PageHeader.vue